import moment from "moment";
import "moment/locale/cs";

import { RouterProvider } from "easy-page-router/react";

import { UserProvider } from "./User";
import Router from "./Router";
import Layout from "./Layout";

moment.locale("cs");

export default function App() {
    return <RouterProvider>
        <UserProvider>
            <Layout>
                <Router />
            </Layout>
        </UserProvider>
    </RouterProvider>;
}

// Fix iOS safari issus with viewport
if (global.window && global.document) { // only for browser
    const updateViewport = () => {
        const metaViewport = document.querySelector('meta[name="viewport"]');
        if (metaViewport) {
            if (window.screen.width <= 600) {
                metaViewport.setAttribute('content', 'width=600, user-scalable=no');
            } else {
                metaViewport.setAttribute('content', 'width=device-width');
            }
        }
    }
    updateViewport();
    window.addEventListener('resize', updateViewport);
}
